import { DateUtils } from "@ticketon/shared-utils";
import { parseTimestamp } from "@ticketon/rewards-core";

const EMPTY_DATE = "—";

/**
 * Display date for an ISO value through the shared `DateUtils`. Date-only values
 * ("YYYY-MM-DD") are read as a local calendar day so they never shift a day back
 * in time zones west of UTC.
 */
export function formatDisplayDate(iso: string | null | undefined): string {
  const timestamp = parseTimestamp(iso);
  if (timestamp === null) return EMPTY_DATE;
  return DateUtils.formatDate(new Date(timestamp));
}

/** Display date plus hours and minutes for an ISO date-time. */
export function formatDisplayDateTime(iso: string | null | undefined): string {
  const timestamp = parseTimestamp(iso);
  if (timestamp === null) return EMPTY_DATE;
  const date = new Date(timestamp);
  const time = date.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
  return `${DateUtils.formatDate(date)} ${time}`;
}

function padTwoDigits(value: number): string {
  return String(value).padStart(2, "0");
}

/** `YYYY-MM-DD` for a date `<input>` from an ISO date or date-time (local calendar day). */
export function toDateInputValue(iso: string | null | undefined): string {
  const timestamp = parseTimestamp(iso);
  if (timestamp === null) return "";
  const date = new Date(timestamp);
  return `${date.getFullYear()}-${padTwoDigits(date.getMonth() + 1)}-${padTwoDigits(date.getDate())}`;
}

/** Today as `YYYY-MM-DD` in the viewer's time zone. */
export function todayDateInputValue(): string {
  return toDateInputValue(new Date().toISOString());
}
